import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77c50ccf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "housing-rooms-card__text" }
const _hoisted_2 = { class: "body-2-semi" }
const _hoisted_3 = { class: "housing-rooms-card__amenities" }
const _hoisted_4 = { class: "housing-rooms-card__modal-amenities" }

import BaseIcon from '@/components/BaseIcon.vue'
import { Room } from '@/models/housings'
import { PropType, ref } from 'vue'
import { roomAmenityIcons } from '@/utils/labelIcons'
import BaseButton from '@/components//BaseButton.vue'
import { FORMATS, SIZES } from '@/enums/components'
import ModalWrapper from '@/components/ModalWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'HousingRoomCard',
  props: {
  housingRoom: {
    type: Object as PropType<Room>,
    default: undefined,
  },
},
  setup(__props) {



const isModalOpen = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["housing-rooms-card", {
      'housing-rooms-card--show-button': __props.housingRoom?.room_amenities.length,
    }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(__props.housingRoom?.type), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.housingRoom?.beds, (bedObj) => {
          return (_openBlock(), _createElementBlock("div", {
            key: bedObj.bed,
            class: "housing-rooms-card__beds"
          }, _toDisplayString(`${bedObj.bed} x${bedObj.amount}`), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.housingRoom?.room_amenities, (amenity) => {
          return (_openBlock(), _createElementBlock("div", {
            key: amenity.id,
            class: "housing-rooms-card__amenity"
          }, [
            _createVNode(BaseIcon, {
              icon: _unref(roomAmenityIcons)[amenity.id],
              size: 24,
              class: "housing-rooms-card__amenity-icon"
            }, null, 8, ["icon"])
          ]))
        }), 128))
      ]),
      _createVNode(BaseButton, {
        format: _unref(FORMATS).SECONDARY,
        size: _unref(SIZES).SMALL,
        type: "button",
        class: "housing-rooms-card__button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (isModalOpen.value = true), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('housingRoom.seeAllAmenities')), 1)
        ]),
        _: 1
      }, 8, ["format", "size"])
    ], 2),
    (isModalOpen.value)
      ? (_openBlock(), _createBlock(ModalWrapper, {
          key: 0,
          title: _ctx.$t('housingRoom.roomAmenities'),
          "modal-size": _unref(SIZES).SMALL,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isModalOpen.value = false))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.housingRoom?.room_amenities, (amenity) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: amenity.id,
                  class: "housing-rooms-card__modal-amenity"
                }, [
                  _createVNode(BaseIcon, {
                    icon: _unref(roomAmenityIcons)[amenity.id],
                    size: 24,
                    class: "housing-rooms-card__amenity-icon"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", null, _toDisplayString(amenity.name), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["title", "modal-size"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})